import { CSSProperties } from "react";

import "./NewButton.scss";

export default function NewButton(props: { text: string; onClick: CallableFunction; containerStyles?: CSSProperties; }) {
  return (
    <div className="new-button-container" style={props.containerStyles} onClick={() => { props.onClick(); }}>
      {props.text}
    </div>
  );
}
